import * as R from 'ramda';
import {Trigger} from '../../models/trigger';

export const getWorkflows = (trigger: Trigger) => R.map(R.when(R.is(Number), R.toString))(R.pathOr([], ['attributes', 'workflows'], trigger));
